import { api } from "@/http/api-client"
import type { TListOrganizationsResponse } from "./types"

export function listOrganizations() {
  return api.get<TListOrganizationsResponse>("/organizations/")
}
